import { render, staticRenderFns } from "./PolicySearch.vue?vue&type=template&id=89ff050c&"
import script from "./PolicySearch.vue?vue&type=script&lang=js&"
export * from "./PolicySearch.vue?vue&type=script&lang=js&"
import style0 from "./PolicySearch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports